import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { CustomImage, CustomPageHeader, Text } from '@src/components';

import List from './List';

import {
  getInstructionsPageList,
  setActiveStep,
  setDetailList,
  setResetList,
  setResetTempList,
  setSelecteAutoUploadDetails,
  setAutoLoadingId,
  setIntegrationId,
  setTotalAutoLoading,
} from '@src/store/slice/autoUploadInstructionsSlice';

import { handleAuthStatus } from '@src/utils/utils';

import { Button } from 'antd';

import IconPlus from '@src/assets/icons/icon-plus.svg';
import '@src/styles/autoUploadInstruction/autoUploadInstructions.scss';

const AutoUploadInstructions = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { userAuthorizationStatus } = useSelector((state) => state?.user);
  const { list, autoLoadingId, integrationId } = useSelector(
    (state) => state?.autoUploadInstructions,
  );

  useEffect(async () => {
    window.scrollTo(0, 0);
  }, [dispatch]);

  useEffect(async () => {
    await dispatch(
      getInstructionsPageList({
        body: { vouId: 1 },
        pageNumber: 1,
        pageSize: 10,
      }),
    );
  }, [dispatch]);

  useEffect(async () => {
    await dispatch(
      setTotalAutoLoading({
        orderProcessType: 2,
        periodType: 1,
        startDay: 1,
        confirmEveryMonth: 0,
        totalCount: 0,
        totalPrice: 0,
        totalPaymentPrice: 0,
        vouId: 1,
        segId: 1000,
        monthChoice: false,
        monthlyPrice: 0.0,
      }),
    );
  }, []);

  useEffect(async () => {
    if (autoLoadingId && autoLoadingId !== 0) {
      await dispatch(setAutoLoadingId(0));
    }
  }, [autoLoadingId]);

  useEffect(async () => {
    if (integrationId && integrationId !== 0) {
      await dispatch(setIntegrationId(0));
    }
  }, [integrationId]);

  const onClickNew = async () => {
    await dispatch(setActiveStep(0));
    await dispatch(setSelecteAutoUploadDetails([]));
    await dispatch(setDetailList([]));
    await dispatch(setResetList([]));
    await dispatch(setResetTempList([]));
    history.push('/ticket-restaurant/auto-upload-instructions/new-instruction');
  };

  return (
    <div className="auto-upload-instructions">
      <CustomPageHeader
        data-testid="auto-upload-instructions"
        title={<Text t="automaticInstallationInstructions" />}
        routes={['ticketRestaurantHeader']}
        showBreadCrumb
        showHelpButton
      >
        <div className="headerText">
          <div className="description">
            <ul>
              <li>
                <Text t="withTheAutomaticLoadingInstructionServiceYourOrders" />
              </li>
              <li>
                <Text t="youCanReviewTheDetailsOfYourAutomatic" />
              </li>
            </ul>
          </div>
          <div className="header-wrapper">
            {!handleAuthStatus(userAuthorizationStatus, 'AutoUploadInstructionsCreate') && (
              <Button
                id="autoUploadInstructions-main-next-btn"
                className="next-btn"
                onClick={onClickNew}
              >
                <CustomImage src={IconPlus} /> <Text t="createNewInstruction" />
              </Button>
            )}
          </div>
        </div>

        {list?.length > 0 && <List />}
      </CustomPageHeader>
    </div>
  );
};

export default AutoUploadInstructions;
